<template>
  <div>        
    <carousel 
        :loop="true"
        :items="itemCount"
        :nav="false"                             
    >
        <img class="category-img" src="img/categories/category_home_decor.jpeg" alt="Home Decor" v-on:click="runCategory('Home Decor')">                        
        <img class="category-img" src="img/categories/category_bluetooth_speakers.jpeg" alt="Bluetooth Speakers" v-on:click="runCategory('Bluetooth Speakers')">                        
        <img class="category-img" src="img/categories/category_smartphones.jpeg" alt="Smartphones" v-on:click="runCategory('Smartphones')">            
        <img class="category-img" src="img/categories/category_pets.jpeg" alt="Pets Supplies" v-on:click="runCategory('Pets Supplies')">            
        <img class="category-img" src="img/categories/category_electronics.jpeg" alt="Electronics" v-on:click="runCategory('Electronics')">            
        <img class="category-img" src="img/categories/category_diy.jpeg" alt="Do it yourself" v-on:click="runCategory('Do it yourself')">            
        <img class="category-img" src="img/categories/category_fashion.jpeg" alt="Fashion Accessories" v-on:click="runCategory('Fashion Accessories')">            
        <img class="category-img" src="img/categories/category_kids_toys.jpeg" alt="Kids Toys" v-on:click="runCategory('Kids Toys')">
    </carousel>
  </div>    
</template>

<script>
import carousel from 'vue-owl-carousel';
export default {
    props: {
        itemCount: Number
    },
    components: {
        carousel        
    },
    data() {
        return {
            isScrolled: false,
            preventSearch: false
        }
    },
    methods: {
        runCategory(text) {
            if (!this.preventSearch) {
                this.$emit('searchForCategory', text)
            }            
        },                
        flagged () {
            this.isScrolled = true;
        },

        preventClick (event) {                      
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    },

    mounted() {
        this.$el.addEventListener('mousedown', () => {            
            this.$el.addEventListener('mousemove', this.flagged)
        });
        this.$el.addEventListener('mouseup', (e) => {            
            if (this.isScrolled) {               
                this.preventSearch = true; 
                e.target.addEventListener('click', this.preventClick);
            } else {
                this.preventSearch = false;
                e.target.removeEventListener('click', this.preventClick);
            }
            this.isScrolled = false;
            this.$el.removeEventListener('mousemove', this.flagged);
        });               
    }
}
</script>

<style>
.category-img:hover {
  opacity: 0.8;
}

</style>